import React from "react";
import PropTypes from "prop-types";
import useAccessibilityContext from "@default/js/accessibility/store/use-accessibility-context";

const Tags = ({ tags }) => {
  tags = tags?.filter((tag) => tag !== null) || [];
  const { simpleDesign } = useAccessibilityContext();

  if (!tags.length) return;

  return (
    <div className="tags-wrapper">
      {tags.map((tag, i) => (
        <span key={i} className="tag">
          {!simpleDesign &&"["}{tag.name}{!simpleDesign &&"]"}
        </span>
      ))}
    </div>
  );
};

Tags.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
};

export default Tags;
